import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const SoneiumLogoCircle = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = square ? 0 : 12;
  let t4;
  if ($[7] !== t3) {
    t4 = <rect fill="#000" height={24} rx={t3} width={24} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M14.418 3.947a8.403 8.403 0 0 1 5.736 10.08 8.397 8.397 0 0 1-9.797 6.205s1.302-1.287 2.624-2.597l.345-.341 1.426-1.416a7.93 7.93 0 0 0 1.27-1.567c1.108-1.802.808-4.082-.728-5.618a4.655 4.655 0 0 0-4.378-1.233ZM3.847 9.968a8.397 8.397 0 0 1 9.782-6.206s-1.086 1.072-2.28 2.255l-.344.34-.345.342c-.515.51-1.016 1.008-1.426 1.417-.489.464-.915.99-1.269 1.564a4.518 4.518 0 0 0 .732 5.627 4.66 4.66 0 0 0 4.38 1.232l-3.511 3.506a8.403 8.403 0 0 1-5.72-10.077Z" fill="#FFF" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <g fill="none" fillRule="nonzero">{t4}{t5}</g>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== rest || $[14] !== t2 || $[15] !== t6) {
    t7 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = rest;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const SoneiumLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm2.418 3.947L10.916 7.46a4.655 4.655 0 0 1 4.378 1.233c1.536 1.536 1.836 3.816.727 5.618a7.93 7.93 0 0 1-1.269 1.567l-1.426 1.416-.345.341-2.537 2.51-.065.064-.022.023a8.397 8.397 0 0 0 9.797-6.205 8.403 8.403 0 0 0-5.736-10.08Zm-.789-.185a8.397 8.397 0 0 0-9.782 6.206 8.403 8.403 0 0 0 5.719 10.077l3.51-3.506a4.66 4.66 0 0 1-4.379-1.232 4.518 4.518 0 0 1-.732-5.627c.354-.574.78-1.1 1.269-1.564.41-.409.911-.906 1.426-1.417l.345-.341.343-.34c1.195-1.184 2.281-2.256 2.281-2.256Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};